module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.comicLoadState === 'error') ? _c('div', {
    staticClass: "comicLoadError"
  }, [_c('h4', [_vm._v(_vm._s(_vm.comicLoadError))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Back to homepage")])], 1) : _vm._e(), _vm._v(" "), (_vm.comicLoadState === 'loading') ? _c('div', [_c('Loader', {
    attrs: {
      "size": 'large'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comicLoadState === 'success') ? _c('div', [_c('ComicNav', {
    attrs: {
      "comicId": _vm.comicId
    }
  }), _vm._v(" "), (_vm.comicData.comic.note) ? _c('div', {
    staticClass: "note",
    domProps: {
      "innerHTML": _vm._s(_vm.comicData.comic.note)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comicData.originPost.text) ? _c('Post', {
    attrs: {
      "post": _vm.comicData.originPost
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.comicData.comic.content.split('./comics').join(_vm.api + '/comics'))
    }
  }), _vm._v(" "), (_vm.comicId == 34) ? _c('ThirtyFour') : _vm._e(), _vm._v(" "), _c('ComicNav', {
    attrs: {
      "comicId": _vm.comicId
    }
  }), _vm._v(" "), _c('NewPost', {
    attrs: {
      "userHasSuggestion": _vm.userHasSuggestion()
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Suggestions")]), _vm._v(" "), (!_vm.hasPostsOfType('suggestion')) ? _c('p', [_vm._v("None yet!")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getPostsOfType('suggestion')), function(post) {
    return _c('Post', {
      key: post.pk_post_id,
      attrs: {
        "post": post
      }
    })
  }), _vm._v(" "), _c('h3', [_vm._v("Questions")]), _vm._v(" "), (!_vm.hasPostsOfType('question')) ? _c('p', [_vm._v("None yet!")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getPostsOfType('question')), function(post) {
    return _c('Post', {
      key: post.pk_post_id,
      attrs: {
        "post": post
      }
    })
  }), _vm._v(" "), _c('h3', [_vm._v("Comments")]), _vm._v(" "), (!_vm.hasPostsOfType('comment')) ? _c('p', [_vm._v("None yet!")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getPostsOfType('comment')), function(post) {
    return _c('Post', {
      key: post.pk_post_id,
      attrs: {
        "post": post
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d69cae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 266
// module chunks = 1